import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import { client } from '@utils/client'
import Modal from '@components/Modal'

import { babyWaitingApproveButton, babyWaitingApproveModal } from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import CurectSvg from '@image/icons/CurectSvg'
import { Button } from 'antd'
const Approved = (props) => {
  const { profileId, open, setOpen, reload } = props
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)

  // const history = useHistory()
  // const params = useParams()

  const handleSubmit = async () => {
    try {
      await client.post(`/profiles/admin/kid/verify`, {
        id: profileId,
      })
      message.success('สำเร็จ')
      reload()
      setOpen(false)
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  /**
   * @type {{
   * footer: React.CSSProperties,
   * body: React.CSSProperties,
   * btn: React.CSSProperties }}
   */

  const style = {
    body: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    footer: {
      display: 'flex',
      justifyContent: 'space-around',
      paddingTop: 24,
      gap: 8,
    },

    btn: {
      borderRadius: '8px',
      width: '170px',
      height: '40px',
      fontWeight: '600',
    },
  }
  return (
    <>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        closable={false}
        maskClosable={false}
        // footer={null}
        width={420}
        bodyStyle={{ padding: 40, overflowY: 'hidden', gap: 24 }}
      >
        <div style={style.body}>
          <CurectSvg width={72} height={86} />
          <Text level={1} type="primary" strong>
            {t(`${babyWaitingApproveModal}.approveInfantConfirm`)}
          </Text>
          <Text
            level={3}
            color={theme.text.black}
            style={{ textAlign: 'center' }}
            semi
          >
            {t(`${babyWaitingApproveModal}.approveInfantInstruction`)}
          </Text>
        </div>

        <div style={style.footer}>
          <Button
            key="cancelSuspendWarning"
            onClick={() => setOpen(false)}
            style={style.btn}
          >
            <Text level={3} color={theme.text.darkGrey} semi>
              {t(`${babyWaitingApproveButton}.back`)}
            </Text>
          </Button>
          <Button
            type="primary"
            key="confirmSuspendWarning"
            onClick={() => handleSubmit()}
            style={style.btn}
          >
            <Text level={3} color={theme.text.white} semi>
              {t(`${babyWaitingApproveButton}.confirm`)}
            </Text>
          </Button>
        </div>
      </Modal>
    </>
  )
}

Approved.propTypes = {
  defaultValues: PropTypes.object,
  reload: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  profileId: PropTypes.string,
}

export default Approved
